import { render } from "./MaterialManager.vue?vue&type=template&id=e3f577c0"
import script from "./MaterialManager.vue?vue&type=script&lang=js"
export * from "./MaterialManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__